import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import endpoints from "../../../services/endpoints";
import { isAuthenticated } from "../../../utils/helpers/functions";
import { AppBar, Toolbar, IconButton, Typography, Box, Button, Avatar, Drawer, useTheme, } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/slices/user-slice";
import SideNav from "./SideNav";
var Header = function (_a) {
    var _b, _c, _d, _e;
    var layoutType = _a.layoutType, drawerContent = _a.drawerContent, _f = _a.title, title = _f === void 0 ? "CorpTrip" : _f, _g = _a.showCreateButton, showCreateButton = _g === void 0 ? true : _g, _h = _a.createLink, createLink = _h === void 0 ? endpoints.web.createTrip : _h;
    var auth_status = isAuthenticated();
    var meta = useSelector(selectUser.userMetaData);
    var _j = useState(false), open = _j[0], setOpen = _j[1];
    var _k = useState(false), hidden = _k[0], setHidden = _k[1];
    var lastScrollY = useRef(0);
    var theme = useTheme();
    useEffect(function () {
        var handleScroll = function () {
            var current = window.pageYOffset || document.documentElement.scrollTop;
            var delta = current - lastScrollY.current;
            // ignore tiny scrolls
            if (Math.abs(delta) < 10)
                return;
            if (current > lastScrollY.current && current > 100) {
                // scrolling down
                setHidden(true);
            }
            else {
                // scrolling up
                setHidden(false);
            }
            lastScrollY.current = current;
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return function () { return window.removeEventListener("scroll", handleScroll); };
    }, []);
    return (_jsx(AppBar, { position: "fixed", color: "inherit", elevation: 1, sx: {
            transform: hidden ? "translateY(-110%)" : "translateY(0)",
            transition: "transform 250ms ease-in-out",
            top: 0,
            zIndex: function (theme) { return theme.zIndex.appBar; },
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        }, children: _jsxs(Toolbar, { sx: { display: "flex", justifyContent: "space-between" }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [_jsx(IconButton, { edge: "start", color: "inherit", onClick: function () { return setOpen(true); }, "aria-label": "menu", children: _jsx(MenuIcon, {}) }), _jsx(Typography, { variant: "h6", component: Link, to: endpoints.web.home, sx: {
                                textDecoration: "none",
                                color: theme.palette.text.primary,
                                fontWeight: 700,
                            }, children: title })] }), _jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [showCreateButton && (_jsx(Button, { component: Link, to: createLink, startIcon: _jsx(AddIcon, {}), variant: "contained", size: "small", children: "Create Trip" })), auth_status ? (_jsx(IconButton, { component: Link, to: "".concat(endpoints.web.profile, "/").concat((_b = meta === null || meta === void 0 ? void 0 : meta.profile) === null || _b === void 0 ? void 0 : _b.username), children: _jsx(Avatar, { alt: (_d = (_c = meta === null || meta === void 0 ? void 0 : meta.profile) === null || _c === void 0 ? void 0 : _c.fullName) !== null && _d !== void 0 ? _d : "User", src: (_e = meta === null || meta === void 0 ? void 0 : meta.profile) === null || _e === void 0 ? void 0 : _e.profilePhotoUrl }) })) : (_jsx(Button, { component: Link, to: endpoints.web.login, children: "Log in" }))] }), _jsx(Drawer, { anchor: "left", open: open, onClose: function () { return setOpen(false); }, children: drawerContent ? (
                    // allow custom drawer content (e.g. manage-trips menu)
                    _jsx(Box, { onClick: function () { return setOpen(false); }, onKeyDown: function () { return setOpen(false); }, children: drawerContent })) : (_jsx(SideNav, { onClose: function () { return setOpen(false); } })) })] }) }));
};
export default Header;
